import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const ViewClaimersModal = ({ codeRequestId, onClose }) => {
  const [claimersData, setClaimersData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchClaimers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [codeRequestId]);

  const fetchClaimers = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.get(`/api/code-requests/${codeRequestId}/claimers`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setClaimersData(response.data.data);
    } catch (err) {
      console.error('Error fetching claimers:', err);
      setError(err.response?.data?.message || 'Failed to fetch claimers');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const renderStars = (rating) => {
    return '⭐'.repeat(rating);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content claimers-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>👥 Code Claimers</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        {loading ? (
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p>Loading claimers...</p>
          </div>
        ) : error ? (
          <div className="error-message">{error}</div>
        ) : claimersData && claimersData.claimers.length === 0 ? (
          <div className="empty-claimers">
            <p>No one has claimed any codes yet</p>
          </div>
        ) : (
          <>
            <div className="claimers-header">
              <h3>{claimersData.gameName}</h3>
              <p className="claimers-count">
                {claimersData.totalClaimed} {claimersData.totalClaimed === 1 ? 'person has' : 'people have'} claimed codes
              </p>
            </div>

            <div className="claimers-list">
              {claimersData.claimers.map((claimer, index) => (
                <div key={index} className="claimer-item">
                  <div className="claimer-info">
                    <Link to={`/profile/${claimer.claimer.username}`} className="claimer-link">
                      {claimer.claimer.avatar && (
                        <img 
                          src={claimer.claimer.avatar} 
                          alt={claimer.claimer.username}
                          className="claimer-avatar"
                        />
                      )}
                      <div className="claimer-details">
                        <span className={`claimer-username ${claimer.claimer.accountType}`}>
                          {claimer.claimer.username}
                        </span>
                        <span className="claimed-date">
                          📅 {formatDate(claimer.claimedAt)}
                        </span>
                      </div>
                    </Link>
                  </div>

                  <div className="vouch-status">
                    {claimer.hasVouched ? (
                      <div className="vouched">
                        <span className="vouch-badge">✅ Vouched</span>
                        {claimer.vouchData && (
                          <div className="vouch-details">
                            <div className="vouch-rating">
                              {renderStars(claimer.vouchData.rating)}
                            </div>
                            {claimer.vouchData.message && (
                              <p className="vouch-message">"{claimer.vouchData.message}"</p>
                            )}
                            {claimer.vouchData.screenshot && (
                              <div className="vouch-screenshot">
                                <img 
                                  src={claimer.vouchData.screenshot} 
                                  alt="Vouch proof" 
                                  onClick={() => window.open(claimer.vouchData.screenshot, '_blank')}
                                />
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    ) : (
                      <span className="not-vouched">⏳ No vouch yet</span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </>
        )}

        <div className="modal-footer">
          <button onClick={onClose} className="btn-primary">
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewClaimersModal;
